var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { CommonUtils } from "./CommonUtils";
import { FeatureStorage } from "./FeatureStorage";
var CollectionUtils = /** @class */ (function () {
    function CollectionUtils() {
    }
    CollectionUtils.get = function (collection, collections) {
        return CollectionUtils.filterEnabledDisabled(collections.get(collection), collections).sort(function (a, b) { return (a.rank || 100) - (b.rank || 100); });
    };
    CollectionUtils.getComponents = function (collection, context) {
        return __awaiter(this, void 0, void 0, function () {
            var items, tmp, result, items_1, items_1_1, item, tmp_1, tmp_1_1, elem, _a, _b, e_1_1;
            var e_2, _c, e_1, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        items = this.get(collection, context.collections);
                        tmp = [];
                        result = [];
                        try {
                            // Starting component loading
                            for (items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                                item = items_1_1.value;
                                tmp.push({
                                    item: item,
                                    component: context.utils.getComponent(item.component)
                                });
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (items_1_1 && !items_1_1.done && (_c = items_1.return)) _c.call(items_1);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 6, 7, 8]);
                        tmp_1 = __values(tmp), tmp_1_1 = tmp_1.next();
                        _f.label = 2;
                    case 2:
                        if (!!tmp_1_1.done) return [3 /*break*/, 5];
                        elem = tmp_1_1.value;
                        _b = (_a = result).push;
                        _e = {
                            item: elem.item
                        };
                        return [4 /*yield*/, elem.component];
                    case 3:
                        _b.apply(_a, [(_e.component = _f.sent(),
                                _e)]);
                        _f.label = 4;
                    case 4:
                        tmp_1_1 = tmp_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _f.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (tmp_1_1 && !tmp_1_1.done && (_d = tmp_1.return)) _d.call(tmp_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/, result.filter(function (elem) {
                            if (!elem.component && localStorage.getItem("eeCanvasVerbose") === "all") {
                                console.log("[EmailEditor] CollectionUtils: Failed to load component ".concat(elem.item.id));
                                return;
                            }
                            return !!elem.component;
                        })];
                }
            });
        });
    };
    CollectionUtils.query = function (collection, component, context) {
        return __awaiter(this, void 0, void 0, function () {
            var items;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getComponents(collection, context)];
                    case 1:
                        items = _a.sent();
                        return [2 /*return*/, items
                                .map(function (elem) {
                                var _a;
                                return ({
                                    item: elem.item,
                                    component: (_a = elem.component) === null || _a === void 0 ? void 0 : _a.query(component)
                                });
                            })
                                .filter(function (elem) {
                                if (!elem.component && localStorage.getItem("eeCanvasVerbose") === "all") {
                                    console.log("[EmailEditor] CollectionUtils: Failed to load component type '".concat(component, "' for ").concat(elem.item.id));
                                    return;
                                }
                                return !!elem.component;
                            })];
                }
            });
        });
    };
    CollectionUtils.filterEnabledDisabled = function (array, collections) {
        var _this = this;
        var context = CommonUtils.getTopWindow().Xrm.Utility.getGlobalContext();
        var flags = collections.get("flags").reduce(function (flags, flag) {
            flags[flag.name] = flag.value;
            return flags;
        }, {});
        return array
            .filter(function (d) {
            if (typeof d.disabled === "string") {
                return !_this.parseCondition(flags[d.disabled], collections);
            }
            return d.disabled !== true;
        })
            .filter(function (d) {
            if (typeof d.enabled === "string") {
                return _this.parseCondition(flags[d.enabled], collections);
            }
            return d.enabled !== false;
        });
    };
    CollectionUtils.getFlagValue = function (name, collections) {
        var flag = collections.get("flags").find(function (f) { return f.name === name; });
        return flag != null ? this.parseCondition(flag.value, collections) : null;
    };
    CollectionUtils.parseCondition = function (condition, collections) {
        var _this = this;
        if (condition) {
            if (Array.isArray(condition.conditions) && condition.operator) {
                if (!condition.conditions.length) {
                    return false;
                }
                switch (condition.operator.toLowerCase()) {
                    case "and":
                        return condition.conditions
                            .map(function (cond) { return _this.parseCondition(cond, collections); })
                            .reduce(function (cond, result) { return cond && result; }, true);
                    case "or":
                        return condition.conditions
                            .map(function (cond) { return _this.parseCondition(cond, collections); })
                            .reduce(function (cond, result) { return cond || result; }, false);
                }
            }
            else if (Array.isArray(condition.and)) {
                return condition.and
                    .map(function (cond) { return _this.parseCondition(cond, collections); })
                    .reduce(function (cond, result) { return cond && result; }, true);
            }
            else if (Array.isArray(condition.or)) {
                return condition.or
                    .map(function (cond) { return _this.parseCondition(cond, collections); })
                    .reduce(function (cond, result) { return cond && result; }, true);
            }
        }
        return this.parseConditionValue(condition, collections);
    };
    CollectionUtils.parseConditionValue = function (value, collections) {
        if (value === null || value === void 0 ? void 0 : value.not) {
            return !this.parseCondition(value.not, collections);
        }
        else if (value === null || value === void 0 ? void 0 : value.flag) {
            return this.getFlagValue(value.flag, collections);
        }
        else if ((value === null || value === void 0 ? void 0 : value.exist) && (value === null || value === void 0 ? void 0 : value.collection)) {
            return !!collections.get(value.collection).find(function (i) { return i.id === value.exist; });
        }
        else if (value === null || value === void 0 ? void 0 : value.fcs) {
            return this.getFcsValue(value.fcs, value.namespace);
        }
        else if (value === null || value === void 0 ? void 0 : value.mktFcs) {
            return FeatureStorage.isFeatureEnabled(value.mktFcs);
        }
        else if (value === null || value === void 0 ? void 0 : value.localStorage) {
            return this.parseValue(localStorage.getItem(value.localStorage));
        }
        return value;
    };
    CollectionUtils.getFcsValue = function (name, namespace) {
        var override = localStorage.getItem("".concat(namespace || this.fcsNamespace, ":").concat(name));
        if (["true", "false"].includes(override)) {
            return override === "true";
        }
        var context = CommonUtils.getTopWindow().Xrm.Utility.getGlobalContext();
        return context.getFeatureControlSetting(namespace || this.fcsNamespace, name);
    };
    CollectionUtils.getConfig = function (names, collections) {
        var configs = Array.isArray(names) ? names.filter(function (name) { return name; }) : [names];
        return collections
            .get("configs")
            .filter(function (config) { return configs.includes(config.name); })
            .sort(function (a, b) { return (a.rank || 0) - (b.rank || 0); });
    };
    CollectionUtils.parseValue = function (str) {
        var _this = this;
        if (str == null) {
            return null;
        }
        if (["true", "false"].includes(str)) {
            return (str === "true");
        }
        if (str.startsWith("[") && str.endsWith("]")) {
            return str
                .substring(1, str.length - 2)
                .split(",")
                .map(function (s) { return s.trim(); })
                .filter(function (s) { return s.length; })
                .map(function (s) { return _this.parseValue(s); });
        }
        return str;
    };
    CollectionUtils.fcsNamespace = "CXP.CXPCore";
    return CollectionUtils;
}());
export { CollectionUtils };
